<template>
  <div>
    <TheHeader :key="$route.fullPath"></TheHeader>

    <IeMessage v-if="$store.getters.isIE" />

    <main class="content --has-no-padding" v-else>
      <transition name="modal-backdrop-transition" appear>
        <router-view />
      </transition>
    </main>

    <TheFooter></TheFooter>

    <ModalProduct v-if="$store.getters.getModalOpen && !$store.getters.isIE" />

    <TheLoader v-if="$store.getters.getGlobalLoading && !$store.getters.isIE" />

    <ShoppingSetupModal v-if="showSetupModal" />

    <CustomerTypeModal v-if="showCustomerTypeModal" />
  </div>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';

import IeMessage from '@/views/Common/IeMessage';
import TheHeader from '@/components/TheHeader';
import TheFooter from '@/components/TheFooter';
import ModalProduct from '@/components/ModalProduct';
import TheLoader from '@/components/TheLoader';
import ShoppingSetupModal from '@/components/Configurator/ShoppingSetupModal';
import CustomerTypeModal from '@/components/Common/CustomerTypeModal';

export default {
  components: {
    IeMessage,
    TheHeader,
    TheFooter,
    ModalProduct,
    TheLoader,
    ShoppingSetupModal,
    CustomerTypeModal
  },
  mixins: [logicMixin],
  data () {
    return {
      showSetupModal: false,
      showCustomerTypeModal: false
    };
  },
  mounted () {
    this.$root.$on('showSetupModal', () => {
      if (this.$store.getters.isB2b) {
        const show = localStorage.getItem('setupModal');

        if (show === null) {
          this.showSetupModal = true;
          localStorage.setItem('setupModal', true);
        }
      }
    });

    if (!(this.$route.path.startsWith('/b2c') || this.$route.path.startsWith('/b2b'))) {
      const show = localStorage.getItem('typeChooser');
      if (show === null) {
        this.showCustomerTypeModal = true;
      } else {
        this.$router.push(this.cLink(this.$route.path));
      }
    } else {
      localStorage.setItem('typeChooser', true);
    }

    // if (!(this.$route.path.startsWith('/b2c') || this.$route.path.startsWith('/b2b'))) {
    //   this.showCustomerTypeModal = true;
    // }

    this.$root.$on('closeSetupModal', () => {
      this.showSetupModal = false;
    });

    this.$root.$on('hideCustomerTypeModal', () => {
      localStorage.setItem('typeChooser', true);
      this.showCustomerTypeModal = false;
      this.$router.push(this.cLink(this.$route.path));
    });
  }
};
</script>
